module.exports = __webpack_public_path__ + "img/dell-inspirion.88a6c297.jpg";